import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

let isDev = true;
// Your Firebase config object
const firebaseConfigDev = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

const firebaseConfigProduct = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};
let firebaseConfig = isDev ? firebaseConfigDev : firebaseConfigProduct;
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase services
const storage = getStorage(app);

export { storage };
